import { takeLatest, put } from "redux-saga/effects";
import api from "../../../utils/apiService";
import { ENDPOINT } from "../../../config/endpoints";
import {
  getCustomerDisplayCampaign,
  setCustomerDisplayCampaign,
} from "../../slices/CustomerDisplay";

/**
 * Uplifted from `redux-store/saga/customerDisplay` (apps/web + apps/mobile), which arrived with
 * the customer display on `release_4.0.0`. The two app files are IDENTICAL — same imports, same
 * body, same `takeLatest` — so `shared.ts` OWNS the saga and both platform files are pure
 * re-exports, the same shape as `licenceExpirySaga`.
 *
 * ⚠️ `utils/apiService` and `config/endpoints` are named as FOLDERS on purpose: a `shared.ts`
 * runs on both platforms, so each bundler must pick its own variant. `slices/CustomerDisplay` is
 * a single plain `index.ts` — one definition, nothing platform-specific — so it has no variant
 * to pick.
 */
function* fetchCustomerDisplayCampaignSaga(action: any): Generator<any, void, any> {
  try {
    const customerDisplayId = action.payload?.customerDisplayId;

    const response: any = yield api.request({
      method: "GET",
      url: ENDPOINT.CUSTOMER_DISPLAY.getCustomerDisplayCampaign(customerDisplayId),
      skipGlobalLoader: true,
    } as any);

    if (!response || response?.code || response?.errorCode) {
      console.error("Customer display campaign fetch failed", response);
      return;
    }

    yield put(setCustomerDisplayCampaign(response));
  } catch (error) {
    yield put(setCustomerDisplayCampaign({}));
    console.error("Customer display campaign fetch failed", error);
  }
}

export default function* root(): Generator<any, void, any> {
  yield takeLatest(getCustomerDisplayCampaign.type, fetchCustomerDisplayCampaignSaga);
}
